import LagerPlatsComp from '../../../Components/Lagerplats/Lagerplats';

const LagerplatsView = () => {
  return (
    <div>
      <LagerPlatsComp />
      {/* Additional NewOrder-specific UI */}
    </div>
  );
};

export default LagerplatsView;